/* Two Kxngs product page (Oct 2026): description tabs, adapted from the Empress product page.
   Loaded by sections/main-product.liquid. Styles: assets/tk-pdp.css (.tkp-desc).

   TK descriptions run: feature icons, an <h2> headline, two intro paragraphs, the spec list, then what the
   piece's name means ("Basileus is derived from..."). The icons, headline, first intro paragraph and the
   name's meaning stay in view; the rest (second intro paragraph and the specs) folds into a Details tab
   that sits on top of the Lifetime Guarantee / Shipping / Returns tabs. Headlines keep their own casing.
   Without JavaScript the full description shows. Gift card and any description without a list: untouched. */
(() => {
  if (window.__tkPdp) return;
  window.__tkPdp = true;

  const isList = (el) => el.tagName === 'UL' || el.tagName === 'OL';
  const isHeading = (el) => /^H[1-6]$/.test(el.tagName);
  const text = (el) => el.textContent.replace(/\s+/g, ' ').trim();
  const isBlank = (el) => !text(el) && !el.querySelector('img, picture, video, iframe');

  // What the name means: a paragraph that opens with the quoted name ('"Basileus" is derived...',
  // '"Dominus," derived from Latin...'), straight or curly quotes
  const isMeaning = (el) => el.tagName === 'P' && /^["'‘’“”]\s*[A-Z][\w-]*[,.]?\s*["'‘’“”]/.test(text(el));

  // Six descriptions (Fenrir, Alberich chain, Midas chain, Dominus, Kaiser, Archon) hold the spec list inside
  // another list, some with the name paragraph inside too (<ul><ul>…</ul><p>…</p></ul>). A list with no
  // items of its own is only a wrapper: lift what it holds back to the top level.
  function flatten(prose) {
    let changed = true;
    while (changed) {
      changed = false;
      [...prose.children].forEach((el) => {
        if (!isList(el) || [...el.children].some((child) => child.tagName === 'LI')) return;
        el.replaceWith(...el.childNodes);
        changed = true;
      });
    }
  }

  const DETAILS_ICON = '<path d="M7 3.5h7.5L19 8v12.5H7z" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><path d="M14.5 3.5V8H19M9.5 11.5h7M9.5 14.5h7M9.5 17.5h4.5" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>';

  function initDescription(prose) {
    if (prose.dataset.tkpReady) return;
    prose.dataset.tkpReady = '1';
    flatten(prose);

    const kids = [...prose.children];
    let i = 0;
    while (i < kids.length && kids[i].classList.contains('product-icons')) i += 1;
    if (i < kids.length && isHeading(kids[i])) {
      kids[i].classList.add('tkp-desc__headline');
      i += 1;
    }
    // The first intro paragraph stays
    while (i < kids.length && isBlank(kids[i])) i += 1;
    if (i < kids.length && kids[i].tagName === 'P' && !isMeaning(kids[i])) i += 1;

    const rest = kids.slice(i);
    // Nothing that reads as specs (gift card): leave the description as it is
    if (!rest.some(isList)) return;

    // The name's meaning stays in view, right under the intro; blank paragraphs go
    const fold = [];
    rest.forEach((el) => {
      if (isMeaning(el)) return;
      if (el.tagName === 'P' && isBlank(el)) {
        el.remove();
        return;
      }
      fold.push(el);
    });
    if (!fold.length) return;

    const item = document.createElement('accordion-disclosure');
    item.className = 'accordion tkp-desc__tab';
    item.innerHTML = `
      <details class="accordion__disclosure group" aria-expanded="false">
        <summary>
          <span class="accordion__toggle h6">
            <span class="text-with-icon gap-4"><span class="tkp-desc__icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="28" height="28" focusable="false">${DETAILS_ICON}</svg></span><span>Details</span></span>
            <span class="animated-plus group-expanded:rotate" aria-hidden="true"></span>
          </span>
        </summary>
        <div class="accordion__content prose"></div>
      </details>`;
    const content = item.querySelector('.accordion__content');
    fold.forEach((el) => content.appendChild(el));

    const tabs = document.createElement('div');
    tabs.className = 'tkp-desc__tabs';
    tabs.appendChild(item);
    prose.after(tabs);
    prose.closest('.product-info__block-item')?.classList.add('has-tkp-tabs');
  }

  const boot = () => {
    document.querySelectorAll('.tkp .product-info__block-item[data-block-type="description"] > .prose').forEach(initDescription);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // A product change re-renders the whole buy box; the theme editor reloads sections
  document.addEventListener('variant:change', () => setTimeout(boot, 50));
  document.addEventListener('shopify:section:load', boot);
})();
